import React from "react"

// eslint-disable-next-line no-restricted-imports
import { Container, FlexContainer } from "@carrotfertility/carotene" // please do not import from @carrotfertility/carotene after eslint rule added on 3/20/25
import { BlueBottomBackground } from "./components/BlueBottomBackground"
import { LogoHeaderBar } from "./components/LogoHeaderBar"
import { GuideParser } from "./GuideParser"
import { GuideRouter } from "./GuideRouter"
import { createErrorBoundary } from "../../utils/createErrorBoundary"
import { ErrorPage } from "../../components/views/app/ErrorPage"
import { NavLayout } from "../../components/views/app/navigation/NavLayout"
import { PageLayout } from "#/features/global-ui/page-layout/page-layout"
import { reportError } from "#/utils/ErrorReporting"
import useGetCategories from "../../components/read/shared/useGetCategories"
import { useConditionDepsStatus } from "#/services/contentful/hooks/use-contentful-conditions"
import { CenteredLoadingIndicator } from "#/components/views/molecules/Molecules"

const ImmersiveGuideErrorPage: React.FC = () => (
  <NavLayout>
    <PageLayout>
      <ErrorPage />
    </PageLayout>
  </NavLayout>
)

const GuideErrorBoundary = createErrorBoundary(ImmersiveGuideErrorPage, "ImmersiveGuide")

const ImmersiveGuide = (): JSX.Element => {
  const conditionDeps = useConditionDepsStatus()
  const { isLoading: isCategoriesLoading } = useGetCategories()
  if (conditionDeps.isError) {
    reportError(conditionDeps.error)
    return <ImmersiveGuideErrorPage />
  }

  return (
    <GuideErrorBoundary>
      <Container minHeight="100vh" background={"lightBlue"} sx={{ boxSizing: "border-box", position: "relative" }}>
        <LogoHeaderBar />
        <FlexContainer justifyContent="center" width="100%" padding={["medium", "medium", "medium", "0 0 128px 0"]}>
          <Container
            borderRadius="8px"
            width={["100%", "100%", "900px"]}
            minHeight={["60vh", "60vh", "auto", "auto"]}
            height={["auto", "auto", "auto", "700px"]}
            background={"white"}
            sx={{ zIndex: 1 }}
          >
            {conditionDeps.isLoading || isCategoriesLoading ? (
              <CenteredLoadingIndicator
                style={{
                  position: "relative",
                  top: "50%",
                  transform: "translateY(-50%)"
                }}
              />
            ) : (
              <GuideParser GuideComponent={GuideRouter} />
            )}
          </Container>
        </FlexContainer>
        <BlueBottomBackground />
      </Container>
    </GuideErrorBoundary>
  )
}

export { ImmersiveGuide }
